module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAVhJREFUOE+Nkk0rxFEYxc95hoWXmVFsJiWxkR2lrJDkJSUsjMsXGC9bslFePgFZ2CixmEHZ2tuJxHdgI2L+/7HRzPPoTmaj+M/d3Vu/e85znkNUcQIn6wabBlCgoRCDrTKKC9OYNZHReFaXCFg+jX4ItyLBwMmhqR4lz3BbEck73kSCoZN9BV6TWd3x4Ps82mvI0zIYOgybypgRYfFLj5sv8RTOYUBF5gC9Esik0doAvgLWSViGgZM1GLpi0IOiIEXlphnvjXqdzOHcz+U/f1tEou4L8foLPPs7A8fHeNZ6CKh/yKcxQcpgIqcb/wXH0PGhMWu9FbDgMK4mQ5Hgj9XukuielJCicMuUd7+tvk+jqVSLhpaK1WrCIWQKsFaQL+Vw1DLVrcPwlszpthf5WECHKE8iwT8KcBsJ+sopZSSR05Vy5RbRB+VuJOjt+ZLDbIbApwGBlGz5G3yHrBAKvswxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon35.png
// module id = q7QE
// module chunks = 1